import StorefrontPage from "./StorefrontPage";

export default function HomePage({ apiBaseUrl, storefrontLocale = "en", pageTemplateConfig = {}, themeLayoutConfig = {} }) {
  return (
    <StorefrontPage
      apiBaseUrl={apiBaseUrl}
      storefrontLocale={storefrontLocale}
      pageTemplateConfig={pageTemplateConfig}
      themeLayoutConfig={themeLayoutConfig}
    />
  );
}
